import { MutableRefObject, Ref, RefCallback } from 'react'

interface AssignRefParams<T> {
  ref: Ref<T> | undefined
  value: T | null
}

const assignRef = <T>({ ref, value }: AssignRefParams<T>) => {
  if (typeof ref === 'function') {
    ref(value)
    return
  }
  if (ref) {
    const mutableRef: MutableRefObject<T | null> = ref
    mutableRef.current = value
  }
}

export const mergeRefs =
  <T>(...refs: (Ref<T> | undefined)[]): RefCallback<T> =>
  value => {
    refs.forEach(ref => assignRef({ ref, value }))
  }
